import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id ABD34714-B566-4EDF-B876-93BFB6D254CB
 * name arrow-bottom-right-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-bottom-right-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomRightBoldOutlineIcon = createSvgIcon(<><path d="M9.88,15.54L4.22,9.88L9.88,4.22L15.54,9.88L19.78,5.64V19.78H5.64L9.88,15.54M17.66,10.59L15.54,12.71L9.88,7.05L7.05,9.88L12.71,15.54L10.59,17.66H17.66V10.59Z" /></>, 'ArrowBottomRightBoldOutlineIcon');
export default ArrowBottomRightBoldOutlineIcon